import axios from '../axios-init';

export const testGenStorageFeeByMonthly = params => {
    return axios.get(`/thirdPartyLogin/sina_qq`, { params: { log_id: params.logId } }).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const testGenStorageFeeByDaily = params => {
    return axios.get(`/thirdPartyLogin/sina_qqq`, { params: { } }).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const testRebuildStorageFeeByDaily = params => {
    return axios.get(`/thirdPartyLogin/sina_163`, { params: { dates: params.dates} }).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorList = params => {
    return axios.post(`/storageFeePayment/getDoctorPaymentList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getWarehouseList = params => {
    return axios.post(`/storageFeePayment/getWarehousePaymentList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const storageFeePay = params => {
    return axios.post(`/storageFeePayment/pay`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const warehouseFeeDetail = params => {
    return axios.post(`/storageFeePayment/warehouseFeeDetail`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const warehouseFeeSummary = params => {
    return axios.post(`/storageFeePayment/warehouseFeeSummary`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};






// WEBPACK FOOTER //
// ./src/api/storageFeePaymentService.js